module.exports = __webpack_public_path__ + "img/2.aac36667.jpg";